import { render, staticRenderFns } from "./CollectionGroupPerformanceLock.vue?vue&type=template&id=f0c1da18&scoped=true&"
import script from "./CollectionGroupPerformanceLock.vue?vue&type=script&lang=js&"
export * from "./CollectionGroupPerformanceLock.vue?vue&type=script&lang=js&"
import style0 from "./CollectionGroupPerformanceLock.vue?vue&type=style&index=0&id=f0c1da18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c1da18",
  null
  
)

export default component.exports